<template>
  <div>
    <div id="header-recuperator">
      <b-navbar
        fixed="top"
        toggleable="lg"
        type="light"
        variant="secondary"
        class="shadow"
        style="padding: 0 1rem"
      >
        <b-navbar-toggle target="nav-text-collapse"></b-navbar-toggle>

        <b-navbar-brand
          ><img
            :src="publicPath + 'images/logo_footer.png'"
            style="height: 38px; filter: brightness(2)"
        /></b-navbar-brand>

        <b-collapse id="nav-text-collapse" is-nav>
          <b-navbar-nav>
            <b-nav-item :to="{ name: 'home' }" class="mr-2"
              ><i class="fad fa-home"></i
            ></b-nav-item>

            <b-nav-item :to="{ name: 'debtors' }" class="mr-2"
              >Débiteurs</b-nav-item
            >

            <b-nav-item :to="{ name: 'invoices' }" class="mr-2"
              >Factures</b-nav-item
            >
            <b-nav-item :to="{ name: 'account-statements' }" class="mr-2"
              >Relevés</b-nav-item
            >
            <b-nav-item :to="{ name: 'warrants' }" class="mr-2"
              >Mandats</b-nav-item
            >
          </b-navbar-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-text class="mr-3"
              ><span style="color: #ddd">Recherche</span></b-nav-text
            >
            <mh-input
              class="mt-1"
              :table="table"
              field="type"
              :readonly="$store.getters.isNegotiator"
            ></mh-input>
            <mh-input
              @enter="goSearch"
              class="mt-1 mr-2"
              :table="table"
              field="search"
              :autocomplete="getField()"
            ></mh-input>

            <b-nav-item-dropdown right>
              <!-- Using 'button-content' slot -->
              <template #button-content>
                <span style="color: #ddd">{{
                  $store.getters.userProfile.family_name
                }}</span>
              </template>
              <b-dropdown-item @click="$bvModal.show('change-password')"
                >Changer votre mot de passe</b-dropdown-item
              >
              <b-dropdown-item @click="$store.dispatch('logout')"
                >Se déconnecter</b-dropdown-item
              >
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
    <b-modal
      size="lg"
      title="Changer votre mot de passe"
      id="change-password"
      hide-footer
      title-class="text-center"
    >
      <mh-input class="mt-1" :table="pwd" field="password"></mh-input>
      <mh-input class="mt-3" :table="pwd" field="confirm_password"></mh-input>
      <div class="d-flex justify-content-end mt-3">
        <b-button
          @click="change_password()"
          :disabled="
            pwd.password.value.trim() == '' ||
            pwd.password.value != pwd.confirm_password.value
          "
          variant="success"
          class="mr-2"
          >Confirmer</b-button
        >
        <b-button @click="$bvModal.hide('change-password')">Annuler</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import MhInput from "./MhInput.vue";
import DateTime from "@/services/DateTime.js";
import creditors from "@/services/creditors.js";
export default {
  components: { MhInput },

  data() {
    return {
      publicPath: process.env.BASE_URL,
      myInterval: null,
      table: {
        type: {
          label: null,
          value: "mandat",
          options: [
            {
              value: "mandat",
              text: "Mandat",
            },
            {
              value: "facture",
              text: "Facture",
            },
            {
              value: "debiteur",
              text: "Débiteur",
            },
          ],
        },
        search: {
          label: null,
          type: "varchar",
          value: "",
        },
      },
      pwd: {
        password: {
          value: "",
          label: "Nouveau mot de passe",
          type: "password",
        },
        confirm_password: {
          value: "",
          label: "Confirmer votre nouveau mot de passe",
          type: "password",
        },
      },
    };
  },
  created() {},
  beforeDestroy() {
    clearInterval(this.myInterval);
  },
  methods: {
    toDate(d) {
      return DateTime.humanDateTime(d);
    },
    icon(i) {
      return `<i class="${i}"></i>`;
    },

    goSearch(payload) {
      let id;
      if (payload.table && payload.id) {
        id = payload.id;
      } else {
        id = payload;
      }
      switch (this.table.type.value) {
        case "mandat":
          this.$router.push({ name: "warrantView", params: { id: id } });
          break;
        case "facture":
          this.$router.push({ name: "invoiceView", params: { id: id } });
          break;
        case "debiteur":
          this.$router.push({ name: "debtorEdit", params: { id: id } });
          break;
      }
      this.table.search.value = "";
    },
    getField() {
      switch (this.table.type.value) {
        case "mandat":
          return { idHistory: "globalWarrantID", field: "mandat.ID" };
        case "facture":
          return { idHistory: "globalInvoiceID", field: "facture.ID" };
        case "debiteur":
          return { idHistory: "globalDebtorID", field: "debiteur.ID" };
      }
    },
    change_password() {
      creditors.change_password(this.pwd).then((response) => {
        if (response.data.success) {
          this.$bvToast.toast(response.data.message, {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "success",
            autoHideDelay: 2000,
            solid: false,
          });
          
        } else if (response.data.error) {
          this.$bvToast.toast(response.data.message, {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "danger",
            autoHideDelay: 2000,
            solid: false,
          });
        }
        this.$bvModal.hide('change-password')
      });
    },
  },
};
</script>
<style lang="scss">
.nav-link {
  font-size: 0.9rem !important;
}
.history-dropdown .dropdown-menu {
  max-height: 50vh;
  overflow-y: auto;
}
</style>
<style lang="scss" scoped>
.form-control[type="text"] {
  transition: all 0.3s;
}
.navbar-brand img {
  height: 47px;
}
.navbar-light .navbar-toggler {
  color: gray !important;
}
#header-recuperator a {
  color: #ddd !important;
}
</style>